import request from '@/utils/request'


// 查询用户浏览列表
export function listBrowse(query) {
  return request({
    url: '/user/user-browse/list',
    method: 'get',
    params: query
  })
}

// 查询用户浏览分页
export function pageBrowse(query) {
  return request({
    url: '/user/user-browse/page',
    method: 'get',
    params: query
  })
}

// 查询用户浏览详细
export function getBrowse(data) {
  return request({
    url: '/user/user-browse/detail',
    method: 'get',
    params: data
  })
}

// 新增用户浏览
export function addBrowse(data) {
  return request({
    url: '/user/user-browse/add',
    method: 'post',
    data: data
  })
}

// 修改用户浏览
export function updateBrowse(data) {
  return request({
    url: '/user/user-browse/edit',
    method: 'post',
    data: data
  })
}

// 删除用户浏览
export function delBrowse(data) {
  return request({
    url: '/user/user-browse/delete',
    method: 'post',
    data: data
  })
}
